<template>
  <div>
    <spinner v-if="loading"></spinner>

    <div>
      <h1 class="text-xl text-left text-gray-700 font-medium">
        เปรียบเทียบการประเมินรายบุคคล
      </h1>

      <!-- <a-month-picker placeholder="Select month" /> -->

      <div class="flex items-center mt-4 mb-12">
        <a-select
          mode="multiple"
          class="w-full"
          placeholder="ป้อนรายชื่อที่ต้องการ"
          v-model="userIds"
          :show-arrow="true"
          :filter-option="false"
          @search="filterUser"
          @change="filterUser"
        >
          <a-select-option
            v-for="employee in filteredEmployees"
            title="dsadasd"
            :value="employee.id"
            :key="`${employee.firstname} ${employee.lastname}`"
          >
            {{ employee.firstname }} {{ employee.lastname }}
          </a-select-option>

          <!-- <slot name="remove-icon">
            dsad
          </slot> -->
        </a-select>

        <a-button @click="fetchReport" class="ml-6" type="primary"
          >เรียกดูข้อมูล</a-button
        >
      </div>

      <div class="card">
        <h1 class="text-lg text-center font-bold mb-4">ด้านคุณภาพชีวิต - WHOQOL</h1>

        <div v-if="!loading">
          <whoqol-compare-bar-chart
            :style="`position: relative; height: ${300 * whoqolMaxDataSize}px`"
            :datasets="whoqolChartDataSets"
            :labels="whoqolChartLabels"
          ></whoqol-compare-bar-chart>
        </div>

        <div v-if="questionReportWhoqol" class="flex justify-end">
          <button
            class="text-primary text-md border border-solid border-primary rounded-md py-1 px-4 flex"
            @click="exportWhoqolQuestionReport"
          >
            ดาวน์โหลดเอกสารคำถาม
          </button>
        </div>
      </div>

      <div class="card">
        <h1 class="text-lg text-center font-bold mb-4">
          ด้านพฤติกรรมสร้างเสริมสุขภาพ - HPLP
        </h1>

        <div v-if="!loading">
          <assessment-compare-bar-chart
            :style="`position: relative; height: ${300 * hplpMaxDataSize}px`"
            :datasets="chartDataSets"
            :labels="chartLabels"
          ></assessment-compare-bar-chart>
        </div>

        <div v-if="questionReportHplp" class="flex justify-end">
          <button
            class="text-primary text-md border border-solid border-primary rounded-md py-1 px-4 flex"
            @click="exportQuestionReport"
          >
            ดาวน์โหลดเอกสารคำถาม
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssessmentCompareBarChart from "@/components/charts/AssessmentCompareBarChart";
import WhoqolCompareBarChart from "@/components/charts/WhoqolCompareBarChart";

import axios from "axios";
import Spinner from "@/components/loading/Spinner";
import collect from "collect.js";
import debounce from "lodash/debounce";
import XLSX from "xlsx";

export default {
  components: {
    AssessmentCompareBarChart,
    WhoqolCompareBarChart,
    Spinner,
  },
  created() {},
  data() {
    this.filterUser = debounce(this.filterUser, 350);

    return {
      loading: false,
      employees: [],
      filteredEmployees: [],

      dataSets: [],
      whoqolDataSets: [],

      questionReportHplp: [],
      questionReportWhoqol: [],

      userIds: [],
    };
  },
  methods: {
    async filterUser(value) {
      try {
        const response = await axios({
          method: "GET",
          url: `${process.env.VUE_APP_API_URL}/user/?query=${value}`,

          // headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
        });

        this.filteredEmployees = response.data;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async fetchReport() {
      await this.fetchDataSets();
      await this.fetchQuestionReport();
    },
    async fetchDataSets() {
      this.loading = true;

      try {
        await this.fetchHplpDataSets();
        await this.fetchWhoqolDataSets();
      } catch (error) {
        this.loading = false;
      }
    },
    async fetchHplpDataSets() {
      try {
        const response = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URL}/report/hplp/compare/chart-data`,
          data: {
            userIds: this.userIds,
          },
          // headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
        });

        this.dataSets = response.data;
      } catch (error) {}
    },
    async fetchWhoqolDataSets() {
      try {
        const response = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URL}/report/whoqol/compare/chart-data`,
          data: {
            userIds: this.userIds,
          },
          // headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
        });

        this.whoqolDataSets = response.data;
      } catch (error) {}
    },
    async fetchQuestionReport() {
      await this.fetchHplpQuestionReport();
      await this.fetchWhoqolQuestionReport();
    },
    async fetchHplpQuestionReport() {
      this.loading = true;
      try {
        const response = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URL}/report/hplp/question/compare`,
          data: {
            // month: 10,
            // year: 2021,
            userIds: this.userIds,
          },
          // headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
        });

        this.questionReportHplp = response.data;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async fetchWhoqolQuestionReport() {
      this.loading = true;
      try {
        const response = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URL}/report/whoqol/question/compare`,
          data: {
            // month: 10,
            // year: 2021,
            userIds: this.userIds,
          },
          // headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
        });

        this.questionReportWhoqol = response.data;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async exportQuestionReport() {
      const report = this.questionReportHplp;

      const riskWorkSheet = XLSX.utils.json_to_sheet(report, {});

      const workBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workBook, riskWorkSheet, "HPLP");

      XLSX.writeFile(workBook, `รายงาน_HPLP${Date.now()}.xlsx`);
    },

    async exportWhoqolQuestionReport() {
      const report = this.questionReportWhoqol;

      const riskWorkSheet = XLSX.utils.json_to_sheet(report, {});

      const workBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workBook, riskWorkSheet, "WHOQOL");

      XLSX.writeFile(workBook, `รายงาน_WHOQOL${Date.now()}.xlsx`);
    },
  },
  computed: {
    hplpMaxDataSize() {
      if (this.dataSets.length == 0) {
        return 1;
      }

      return this.dataSets?.labels?.length;
    },
    chartDataSets() {
      return this.dataSets?.data?.map((dataSet, index) => {
        return {
          label: `ครั้งที่ ${index + 1}`,
          backgroundColor: "#9E76B4",
          data: dataSet,
        };
      });
    },
    chartLabels() {
      return this.dataSets.labels;
    },

    whoqolMaxDataSize() {
      if (this.whoqolDataSets.length == 0) {
        return 1;
      }

      return this.whoqolDataSets?.labels?.length;
    },
    whoqolChartDataSets() {
      return this.whoqolDataSets?.data?.map((dataSet, index) => {
        return {
          label: `ครั้งที่ ${index + 1}`,
          backgroundColor: "#9E76B4",
          data: dataSet,
        };
      });
    },
    whoqolChartLabels() {
      return this.whoqolDataSets.labels;
    },
  },
};
</script>
